import React, { useState } from 'react';
import {
  Form,
  Input,
  Button,
  Checkbox,
  Layout,
  Typography,
  Spin,
  message,
  Divider,
  Row,
  Col
} from 'antd';
import { UserOutlined, LockOutlined, GoogleOutlined, SafetyOutlined, RocketOutlined, TeamOutlined, GlobalOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import DiffInsightLandingPage from '../LandingPages/DiffInsightLandingPage';
import { jwtDecode } from 'jwt-decode';
import jwtEncode from 'jwt-encode';
import Cookies from 'js-cookie';
import { BASE_URL } from '../Components/Constant';
import ApiService from '../Components/apiService';

const { Content } = Layout;
const { Title, Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Add CSS animations
  React.useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-20px); }
      }
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      .animate-fadeInUp {
        animation: fadeInUp 0.6s ease forwards;
      }
    `;
    document.head.appendChild(style);
    
    // Trigger animations
    setTimeout(() => setIsVisible(true), 100);
    
    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);

  // Redirect to specific landing page based on path
  if (location.pathname.includes('DiffInsight')) {
    return <DiffInsightLandingPage />;
  } else if (location.pathname.includes('RCAMigration')) {
    // return <RCAMigrationLandingPage />;
  }

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const token = jwtEncode(
        { username: values.username, password: values.password },
        'OUR_SECRET',
        { algorithm: 'HS256' }
      );

      jwtDecode(token); // verify payload

      // Determine environment based on current URL
      const hostname = window.location.hostname;
      const env = hostname.includes('test') ? 'sandbox' : 'production';

      const apiService = new ApiService(`${BASE_URL}/login`, {
        'Content-Type': 'application/json'
      }, 'POST', { tokens: token, env: env });

      const response = await apiService.makeCall();

      const tokenRes = response.token;
      const username = response.user.username;
      const email = response.user.email;
      const name = response.user.Name;
      const userId = response.user._id;
      const orgId = response.user.org_id;
      const loginUserCurrency = response.user.currency;
      const image= response.user.image;

      if (token && username && email) {
        Cookies.set('tokenRes', tokenRes, { expires: 7 });
        Cookies.set('username', username, { expires: 7 });
        Cookies.set('email', email, { expires: 7 });
        Cookies.set('name', name, { expires: 7 });
        Cookies.set('userId', userId, { expires: 7 });
        Cookies.set('orgId', orgId, { expires: 7 });
        Cookies.set('userCurrency', loginUserCurrency, { expires: 7 });
        Cookies.set('env', env, { expires: 7 });
        Cookies.set('image', image, { expires: 7 });
      }

      setLoading(false);
      navigate('/');
    } catch (err) {
      setLoading(false);
      const errorMessage =
        err && typeof err === 'object'
          ? Object.entries(err)
            .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`)
            .join(' | ')
          : 'Login failed! Enter Correct Credentials.';
      message.error(errorMessage);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1D3557 0%, #457B9D 50%, #FCD6C7 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Spin spinning={loading} size="large" tip="Signing you in...">
        {/* Background decorative elements */}
        <div
          style={{
            position: "absolute",
            top: "-50px",
            right: "-50px",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background: "rgba(254, 114, 0, 0.1)",
            animation: "float 6s ease-in-out infinite",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-100px",
            left: "-100px",
            width: "300px",
            height: "300px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.05)",
            animation: "float 8s ease-in-out infinite reverse",
          }}
        />

        {/* Header */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            padding: "20px 40px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <div
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#FFFFFF",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(-20px)",
              transition: "all 0.8s ease",
            }}
          >
            Aptify
          </div>
          {/* <Button
            type="text"
            onClick={() => navigate("/createOrg")}
            style={{
              color: "#FFFFFF",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              borderRadius: "6px",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(-20px)",
              transition: "all 0.8s ease 0.2s",
            }}
          >
            Create Organization
          </Button> */}
        </div>

        <Row style={{ minHeight: "100vh", paddingTop: "80px" }}>
          {/* Left: Login Form */}
          <Col
            xs={24}
            lg={14}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "40px",
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                borderRadius: "20px",
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(20px)",
                padding: "40px",
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateY(0) scale(1)" : "translateY(30px) scale(0.9)",
                transition: "all 1s ease 0.3s",
              }}
            >
              <div style={{ textAlign: "center", marginBottom: "30px" }}>
                <Title level={2} style={{ color: "#1D3557", marginBottom: "8px", fontSize: "28px" }}>
                  Welcome Back
                </Title>
                <Text style={{ color: "#457B9D", fontSize: "16px" }}>
                  Sign in to continue to your workspace
                </Text>
              </div>

              <Form
                name="login"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                style={{ marginTop: "20px" }}
              >
                <Form.Item
                  label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Username</span>}
                  name="username"
                  rules={[{ required: true, message: 'Please input your username!' }]}
                >
                  <Input 
                    prefix={<UserOutlined style={{ color: "#457B9D" }} />} 
                    placeholder="Enter your username" 
                    size="large"
                    style={{
                      borderRadius: "8px",
                      border: "2px solid #f0f0f0",
                      transition: "all 0.3s ease",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#FE7200";
                      e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#f0f0f0";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Password</span>}
                  name="password"
                  rules={[{ required: true, message: 'Please input your password!' }]}
                >
                  <Input.Password 
                    prefix={<LockOutlined style={{ color: "#457B9D" }} />} 
                    placeholder="Enter your password" 
                    size="large"
                    style={{
                      borderRadius: "8px",
                      border: "2px solid #f0f0f0",
                      transition: "all 0.3s ease",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#FE7200";
                      e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#f0f0f0";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: "20px" }}>
                    <Form.Item name="remember" valuePropName="checked" noStyle>
                      <Checkbox style={{ color: "#1D3557" }}>Remember Me</Checkbox>
                    </Form.Item>
                    <Link to="/forgot-password" style={{ color: "#FE7200", fontWeight: "500" }}>Forgot Password?</Link>
                  </div>
                </Form.Item>

                <Form.Item style={{ marginBottom: "20px" }}>
                  <Button 
                    type="primary" 
                    htmlType="submit" 
                    block 
                    size="large"
                    loading={loading}
                    style={{
                      backgroundColor: "#FE7200",
                      borderColor: "#FE7200",
                      borderRadius: "8px",
                      height: "50px",
                      fontSize: "16px",
                      fontWeight: "600",
                      boxShadow: "0 4px 12px rgba(254, 114, 0, 0.3)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#e85d00";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#FE7200";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    {loading ? <Spin /> : "Sign In"}
                  </Button>
                </Form.Item>
              </Form>

              {/* <Divider 
                plain 
                style={{ 
                  color: "#8898aa", 
                  fontSize: "14px",
                  margin: "20px 0"
                }}
              >
                or continue with
              </Divider>

              <Button
                block
                size="large"
                style={{
                  backgroundColor: '#ffffff',
                  color: '#3c4043',
                  border: '1px solid #dadce0',
                  height: '50px',
                  fontWeight: '500',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '12px',
                  fontFamily: 'Google Sans, Roboto, Arial, sans-serif',
                  boxShadow: '0 1px 2px 0 rgba(60,64,67,.30), 0 1px 3px 1px rgba(60,64,67,.15)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f8f9fa';
                  e.currentTarget.style.boxShadow = '0 1px 3px 0 rgba(60,64,67,.30), 0 4px 8px 3px rgba(60,64,67,.15)';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.boxShadow = '0 1px 2px 0 rgba(60,64,67,.30), 0 1px 3px 1px rgba(60,64,67,.15)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
                onClick={() => message.info('Google Login coming soon')}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  style={{ marginRight: '8px' }}
                >
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                Continue with Google
              </Button>

              <div style={{ textAlign: "center", marginTop: "24px" }}>
                <Text style={{ color: "#457B9D" }}>
                  Don't have an account? <Link to="/register" style={{ color: "#FE7200", fontWeight: "500" }}>Create Organization</Link>
                </Text>
              </div> */}
            </div>
          </Col>

          {/* Right: Features */}
          <Col
            xs={24}
            lg={10}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: "60px 40px",
              background: "rgba(255, 255, 255, 0.05)",
              backdropFilter: "blur(10px)",
              borderRadius: "10px",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0) scale(1)" : "translateY(30px) scale(0.9)",
              transition: "all 1s ease 0.5s",
            }}
          >
            <div style={{ textAlign: "center", marginBottom: "40px" }}>
              <SafetyOutlined style={{ fontSize: "80px", color: "#FE7200", marginBottom: "20px" }} />
              <Title level={2} style={{ fontSize: "32px", color: "#FFFFFF", marginBottom: "16px" }}>
                Secure & Reliable Platform
              </Title>
              <Text style={{ fontSize: "18px", color: "rgba(255, 255, 255, 0.9)" }}>
                Your trusted workspace for enterprise solutions
              </Text>
            </div>

            <Row gutter={[20, 20]}>
              <Col span={24}>
                <div style={{ 
                  background: "rgba(255, 255, 255, 0.95)", 
                  padding: "20px", 
                  borderRadius: "12px",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(10px)",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)"
                }}>
                  <div style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background: "rgba(254, 114, 0, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <RocketOutlined style={{ fontSize: "24px", color: "#FE7200" }} />
                  </div>
                  <div>
                    <Title level={5} style={{ color: "#FE7200", marginBottom: "4px", margin: 0 }}>
                      Fast Performance
                    </Title>
                    <Text style={{ color: "#457B9D", fontSize: "14px" }}>
                      Lightning-fast load times and responsive interface
                    </Text>
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div style={{ 
                  background: "rgba(255, 255, 255, 0.95)", 
                  padding: "20px", 
                  borderRadius: "12px",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(10px)",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)"
                }}>
                  <div style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background: "rgba(254, 114, 0, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <TeamOutlined style={{ fontSize: "24px", color: "#FE7200" }} />
                  </div>
                  <div>
                    <Title level={5} style={{ color: "#FE7200", marginBottom: "4px", margin: 0 }}>
                      Team Collaboration
                    </Title>
                    <Text style={{ color: "#457B9D", fontSize: "14px" }}>
                      Work together seamlessly with your team
                    </Text>
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div style={{ 
                  background: "rgba(255, 255, 255, 0.95)", 
                  padding: "20px", 
                  borderRadius: "12px",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(10px)",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)"
                }}>
                  <div style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background: "rgba(254, 114, 0, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <GlobalOutlined style={{ fontSize: "24px", color: "#FE7200" }} />
                  </div>
                  <div>
                    <Title level={5} style={{ color: "#FE7200", marginBottom: "4px", margin: 0 }}>
                      Global Access
                    </Title>
                    <Text style={{ color: "#457B9D", fontSize: "14px" }}>
                      Access your workspace from anywhere in the world
                    </Text>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

export default Login;
